import React from 'react';
import Typography from '@cld/typography';

export const Header = ({ assets }) => {
    return (
        <>
            <Typography size="lg" as='h4'>
                Assets selected: {assets?.length}
            </Typography>

            <Typography size="sm" type="lowContrast">
                Select the transformation preset you want to apply to these assets and click 'Download'.
            </Typography>
        </>
    );
};
